import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { utils, translate } from 'parking-react-common'

import { interrogations, users, ui, filters } from '../redux'

import List from '../components/List'
import Button from '../components/Button'
import UserDisplay from '../components/UserDisplay'
import Map, { Marker } from './Map'
import TZDateTime from './TZDateTime'

const InterrogationsList = ({ dataSelector, dataURL, t, dispatch }) => {
    const columns = [
        {
            key    : 'user',
            title  : t('User'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ cellData } />
            )
        },
        {
            key   : 'license_plate',
            title : t('Vehicle')
        },
        {
            key    : 'moment',
            title  : t('Moment'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key    : 'position',
            title  : t('Position'),
            render : ({ cellData, rowData }) => { // eslint-disable-line react/prop-types
                const [lng, lat] = cellData.coordinates
                const action = ui.showModal({
                    title   : t('Interrogation for {{license_plate}}', { license_plate: rowData.license_plate }),
                    message : t('On {{date}}', { date: utils.formatTimestamp(rowData.moment) }),
                    intent  : ui.INTENT.primary,
                    content : (
                        <div>
                            <Map
                                style={ { height: '250px', zIndex: 1, flexGrow: 1 } }
                                center={ { lat, lng } }
                            >
                                <Marker position={ { lat, lng } } />
                            </Map>
                        </div>
                    )
                })

                return (
                    <Button
                        onClick={ () => dispatch(action) }
                        label={ t('Open Map') }
                        size={ ui.SIZE.default }
                        intent={ ui.INTENT.default }
                        icon="fa/map-marker"
                    />
                )
            }
        }
    ]

    const searchKeys = ['license_plate', ...users.getSearchKeys()]
    const filterKeys = {
        moment: filters.TYPES.dateRange
    }

    return (
        <List
            title={ t('Interrogations') }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
            sortBy="moment"
        />
    )
}

InterrogationsList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

InterrogationsList.defaultProps = {
    dataSelector : interrogations.getAll,
    dataURL      : 'interrogations'
}

function mapStateToProps(state, ownProps) {
    const dataSelector = (state) => {
        const interrogations = ownProps.dataSelector(state)
        return utils.enhance(interrogations, {
            user: (interrogation) => users.getForID(interrogation.user)(state)
        })
    }

    return {
        dataSelector
    }
}


export default translate()(connect(mapStateToProps)(InterrogationsList))
